/**
 * SpinnerService – Drop-in replacement for SpinnerService.
 * Uses a global loading BehaviorSubject that the layout listens to,
 * instead of ngx-spinner DOM injections.
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
    /** True when at least one show() call is pending. */
    readonly loading$ = new BehaviorSubject<boolean>(false);

    private counter = 0;

    /** Compatible with SpinnerService.show() – returns a resolved Promise. */
    show(): Promise<void> {
        this.counter++;
        this.loading$.next(true);
        return Promise.resolve();
    }

    /** Compatible with SpinnerService.hide() – returns a resolved Promise. */
    hide(): Promise<void> {
        this.counter = Math.max(0, this.counter - 1);
        if (this.counter === 0) {
            this.loading$.next(false);
        }
        return Promise.resolve();
    }
}
